interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '成全影院',
      url: 'https://atilol.cn',
      description: '成全影院提供高清画质流畅播放，不卡顿蓝光体验，无广告干扰，免费在线观看电影电视剧全集。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-6666',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://weibo.com/chengquan',
        'https://www.douyin.com/user/chengquan',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '成全影院',
      url: 'https://atilol.cn',
      description: '成全影院提供高清画质流畅播放，不卡顿蓝光体验，无广告干扰，免费在线观看电影电视剧全集。',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://atilol.cn/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
      inLanguage: 'zh-CN',
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      publisher: {
        '@type': 'Organization',
        name: '成全影院',
        url: 'https://atilol.cn',
      },
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = baseSchemas[type];

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}